import { Link, useMatchRoute, type LinkProps } from "@tanstack/react-router";
import { Button } from "~/components/button";

interface NavigationItemProps {
  label: string;
  path: LinkProps["to"];
  exact?: boolean;
}

const NavigationItem = ({ label, path, exact }: NavigationItemProps) => {
  const matchRoute = useMatchRoute();
  const isActive = Boolean(matchRoute({ to: path }));

  return (
    <Link
      to={path}
      onClick={(e) => isActive && e.preventDefault()}
      className="group"
      activeOptions={{ exact, includeSearch: false }}
    >
      <Button
        variant="link"
        label={label}
        className="text-sm transition duration-300 ease-in-out group-[.active]:text-primary-600"
      />
    </Link>
  );
};

interface NavigationBarProps {
  items: { label: string; path: LinkProps["to"]; exact?: boolean }[];
}

export const NavigationBar = ({ items }: NavigationBarProps) => {
  return (
    <nav className="relative">
      <div className="flex space-x-2 relative">
        {items.map((item) => (
          <NavigationItem
            key={item.path}
            label={item.label}
            path={item.path}
            exact={item.exact}
          />
        ))}
      </div>
    </nav>
  );
};
